var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3236 30.6859L28.508 22.8703C31.1346 17.8734 30.3018 11.5313 26.1377 7.36719C20.9486 2.17813 12.5564 2.17813 7.36738 7.36719C2.17832 12.5563 2.17832 20.9484 7.36738 26.1375C9.92988 28.7 13.3252 30.0453 16.7205 30.0453C18.8346 30.0453 20.9486 29.5328 22.8705 28.5719L30.7502 36.4516C31.5189 37.2203 32.5439 37.6047 33.5689 37.6047C34.594 37.6047 35.6189 37.2203 36.3877 36.4516C37.9252 34.7859 37.9252 32.2875 36.3236 30.6859ZM9.16113 24.2797C4.99707 20.1156 4.99707 13.325 9.16113 9.16094C11.2752 7.04688 13.9658 6.02188 16.7205 6.02188C19.4752 6.02188 22.2299 7.04688 24.2799 9.16094C28.4439 13.325 28.4439 20.1156 24.2799 24.2797C20.1158 28.4438 13.3252 28.4438 9.16113 24.2797ZM34.5299 34.5297C33.9533 35.1063 33.0564 35.1063 32.5439 34.5297L25.0486 27.0344C25.433 26.7141 25.7533 26.3938 26.1377 26.0734C26.458 25.7531 26.7783 25.3688 27.0986 24.9844L34.5939 32.4797C35.1064 33.0563 35.1064 34.0172 34.5299 34.5297Z",
    fill: "#0e131c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3466 15.5031C18.2576 15.5031 17.1685 15.5031 16.0794 15.5031C16.5919 14.2219 17.1685 12.9406 17.681 11.6594C17.9372 11.0188 17.3607 10.25 16.7841 10.0578C16.0154 9.86563 15.5029 10.3141 15.1826 10.9547C14.4138 12.7484 13.6451 14.6063 12.8763 16.4C12.556 17.1688 13.3888 18.0016 14.0935 18.0016H17.1044C16.4638 19.1547 15.8872 20.3078 15.2466 21.4609C14.4779 22.9344 16.656 24.2156 17.4888 22.7422C18.4497 20.9484 19.4107 19.1547 20.3716 17.3609C20.8841 16.5922 20.3076 15.5031 19.3466 15.5031Z",
    fill: "#0e131c"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch01);
export default __webpack_public_path__ + "static/media/search01.41f2935136b9086833dc4c23034dc2f1.svg";
export { ForwardRef as ReactComponent };